export default __webpack_public_path__ + "static/media/plt5.02302666.png";